import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 bg-teal relative overflow-hidden" data-id="element-192">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-193"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-195">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/10 mb-8 backdrop-blur-sm" data-id="element-196">
            <BrainCircuit size={40} className="text-white" data-id="element-197" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-198">
            Presentamos el Método de <br className="hidden md:block" data-id="element-199" />
            <span className="text-pink-light italic" data-id="element-200">Conexión de Señales</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-teal-50 leading-relaxed text-left md:text-center max-w-3xl mx-auto" data-id="element-201">
            <p data-id="element-202">
              A diferencia del entrenamiento tradicional, este protocolo se basa
              en la neuropsicología infantil.
            </p>
            <p className="font-medium text-white text-xl md:text-2xl" data-id="element-203">
              En lugar de obligar al niño, reprogramamos la comunicación entre
              su sistema nervioso y su vejiga en 72 horas.
            </p>
            <p data-id="element-204">
              Durante un fin de semana, hackeamos los intervalos de hidratación
              y las señales corporales para que el control sea natural e
              inevitable.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}